import React from "react";
import Tilt from "react-parallax-tilt";
import Section from "./Section";
import Reveal from "./Reveal";
import { tech } from "../techIcons";
import { projects } from "../data";

function Projects() {
  return (
    <Section id="projects" title="Client & Company" accent="Projects">
      <div className="projects-grid">
        {projects.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 120}>
          <Tilt tiltMaxAngleX={8} tiltMaxAngleY={8} glareEnable glareMaxOpacity={0.12} scale={1.02}>
          <article className="card project">
            <span className="project-num">{String(i + 1).padStart(2, "0")}</span>
            <h3>{p.title}</h3>
            <p className="company">{p.subtitle}</p>
            <p className="muted small">{p.org}</p>
            <p>{p.description}</p>
            <div className="chips">
              {p.tech.map((t) => {
                const hit = tech.find((x) => x.name.toLowerCase() === t.toLowerCase() || (t === "Go" && x.name === "Go"));
                return (
                  <span key={t} className="chip" style={hit ? { "--c": hit.color } : undefined}>
                    {hit && <hit.Icon />} {t}
                  </span>
                );
              })}
            </div>
          </article>
          </Tilt>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}

export default Projects;
